import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import BaseState from 'baseapp/store/store'

Vue.use(Vuex)

BaseState.clientid = 1
BaseState.version = 'V 1.1.0'
const state = {
  ...BaseState,
  contractSkuCounts: {}, /* 合同商品选择数量 { CONTRACT_ID: {SKUID: {checked: BOOLEAN, count: COUNT}}} */
  orderFilters: [],
  customCompanyConfig: null
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/apps/buyerapp/store/store.js